/**
 * @description Обёртка над fetch, выполняющая запросы только к локальным API и обрабатывающая 429 ошибки.
 * @param {String} route Апи-роут, например /api/download
 * @param {Object} options Дополнительные опции для fetch
 * @returns {Promise<any>} Ответ в формате JSON
 */
const relativeApiFetch = async (route = "", options = {}) => {
  const res = await fetch(route, options);
  if (
    res.status === 429 &&
    typeof window !== "undefined" &&
    !window.location.pathname.includes("/_captcha")
  ) {
    window.location.reload();
  }
  return res;
};

export default relativeApiFetch;
